export const TableListIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M14 1.33333H2C0.897333 1.33333 0 2.23067 0 3.33333V14.6667H16V3.33333C16 2.23067 15.1027 1.33333 14 1.33333ZM14.6667 3.33333V5.33333H5.33333V2.66667H14C14.368 2.66667 14.6667 2.966 14.6667 3.33333ZM5.33333 6.66667H14.6667V9.33333H5.33333V6.66667ZM4 9.33333H1.33333V6.66667H4V9.33333ZM2 2.66667H4V5.33333H1.33333V3.33333C1.33333 2.966 1.632 2.66667 2 2.66667ZM1.33333 10.6667H4V13.3333H1.33333V10.6667ZM5.33333 13.3333V10.6667H14.6667V13.3333H5.33333Z"
        fill="#A09CAD"
      />
    </svg>
  );
};
